import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20Korean%20manhwa%20characters%20in%20dynamic%20poses%2C%20stylized%20comic%20art%20aesthetic%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20abstract%20brush%20stroke%20background%20with%20soft%20gradients%2C%20dramatic%20lighting%20from%20top%20left%2C%20modern%20manga%20style%2C%20clean%20composition%2C%20no%20text&width=1920&height=1080&seq=hero-bg-main-2026&orientation=landscape"
          alt="韩漫网 - 韩国漫画免费在线观看"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col justify-center px-4 md:px-6">
        <div className="max-w-7xl mx-auto w-full">
          <div className="max-w-2xl">
            <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/40 text-background-50 text-sm font-medium backdrop-blur-sm mb-5">
              <i className="ri-sparkling-line mr-1.5"></i>
              2026 夏季热门连载
            </span>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-4">
              发现你的
              <span className="text-accent-400">下一部</span>
              <br />
              挚爱韩漫
            </h1>

            <p className="text-base md:text-lg text-background-200/90 max-w-lg mb-8 leading-relaxed">
              汇聚全网最全韩漫资源，从经典神作到最新连载，随时随地畅享高质量阅读体验。每日更新，追漫不等待。
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <Link
                to="/category/romance"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>开始探索</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/category/action"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-sm font-semibold hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                <span>热门排行</span>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pb-6">
          <div className="flex items-center gap-6 text-background-200/80 text-sm">
            <div className="flex items-center gap-1.5">
              <i className="ri-user-smile-line"></i>
              <span>50万+ 漫画爱好者</span>
            </div>
            <div className="w-px h-4 bg-background-300/30"></div>
            <div className="flex items-center gap-1.5">
              <i className="ri-book-read-line"></i>
              <span>3000+ 部漫画</span>
            </div>
            <div className="w-px h-4 bg-background-300/30"></div>
            <div className="flex items-center gap-1.5">
              <i className="ri-thumb-up-line"></i>
              <span>98% 好评率</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}